import { SplideSlide } from '@splidejs/react-splide'
import { Splide } from '@splidejs/splide'
import includes from 'lodash/includes'
import join from 'lodash/join'
import map from 'lodash/map'
import React from 'react'

import { VideoSlider } from '@Components/Slider/components/sliders/VideoSlider'
import { Product } from '@Generated/graphql'

import { ImageSlide } from './sliders/ImageSlide'
import { ZoomableSlide } from './sliders/ZoomableSlide'

interface DataSliderProps extends Pick<Product, 'assets'> {
  disableFullscreen?: boolean
  splide?: Splide
  title?: string
  type?: 'fullscreen'
}

export const DataSlider: React.FC<DataSliderProps> = ({
  assets,
  disableFullscreen = false,
  splide,
  title,
  type,
}) => {
  const ImageComponent = type === 'fullscreen' ? ZoomableSlide : ImageSlide

  return (
    <>
      {map(assets, ({ tags, url }, index) => (
        <SplideSlide key={url}>
          {includes(tags, 'video')
            ? (
              <VideoSlider
                index={index}
                source={url}
                splide={splide}
                type={type}
              />
            )
            : (
              <ImageComponent
                alt={`${title || ''} - ${index + 1} - ${join(tags, ' ')}`.trim()}
                disableFullscreen={disableFullscreen}
                index={index}
                source={url}
                splide={splide}
                type={type}
              />
            )}
        </SplideSlide>
      ))}
    </>
  )
}

